import { createActionConst } from '../../../utils/action.utils';

const INVOICE_NAMESPACE = 'INVOICE';

export const STORE_INVOICE = createActionConst(INVOICE_NAMESPACE, 'STORE_INVOICE');
export const CLEAR_INVOICE = createActionConst(INVOICE_NAMESPACE, 'CLEAR_INVOICE');
